import { render, staticRenderFns } from "./DeliveryPointSummary.vue?vue&type=template&id=2d14f387"
import script from "./DeliveryPointSummary.vue?vue&type=script&lang=js"
export * from "./DeliveryPointSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports